import { get } from "../../utils/net";

import type { ApiVersion } from "../../models/apiVersion";

const getApiVersion = async (): Promise<ApiVersion> => {
  const response = await get(`${process.env.REACT_APP_API_PATH}/api/version`, {
    useExactPath: true,
  });

  return response.body;
};

export const versionAPI = {
  getApiVersion,
};
